module.exports = __webpack_public_path__ + "img/c-04.f1b6f566.jpg";